import MainLayout from 'layout/mainLayout';

import RoadmapRecommendation from '../../components/roadmaps/posts/main/RoadMapMainItems';

function MainPage() {
  return (
    <MainLayout>
      <RoadmapRecommendation />
    </MainLayout>
  );
}
export default MainPage;
